<template>
  <el-card>
    <!-- <span slot="header" class="fontSize_16 fontWeight_bold"
      >{{ currentCate }}
    </span> -->
    <el-form label-width="80px" class="form-main" inline>
      <el-form-item>
        <el-select
          v-model="queryParams.is_contract"
          @input="searchHandle"
          size="mini"
          class="input-style-200 line-height-28"
          clearable
          placeholder="合作状态"
        >
          <el-option label="合作中" value="0"></el-option>
          <el-option label="提前对接" value="2"></el-option>
          <el-option label="已断约" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="queryParams.brand_name"
          @input="searchHandle"
          size="mini"
          class="input-style-200 line-height-28"
          placeholder="品牌"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="queryParams.main_products"
          @input="searchHandle"
          size="mini"
          class="input-style-200 line-height-28"
          placeholder="主要产品"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="queryParams.address"
          @input="searchHandle"
          size="mini"
          class="input-style-200 line-height-28"
          placeholder="归属地"
          clearable
        ></el-input>
      </el-form-item>

      <span v-if="purviewVal">
        <el-form-item>
          <el-select
            v-model="queryParams.assign_id_leader"
            size="mini"
            @change="searchHandle"
            clearable
            class="input-style-200 line-height-28"
            placeholder="组长"
          >
            <el-option
              v-for="item in groupList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="queryParams.assign_id"
            size="mini"
            class="input-style-200 line-height-28"
            clearable
            filterable
            @change="searchHandle"
            placeholder="店长"
          >
            <el-option
              v-for="item in shopList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="queryParams.sale_id"
            size="mini"
            class="input-style-200 line-height-28"
            clearable
            filterable
            @change="searchHandle"
            placeholder="销售"
          >
            <el-option
              v-for="item in saleList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </span>
      <el-form-item>
        <el-button
          @click="resetHandle"
          type="primary"
          plain
          size="mini"
          icon="el-icon-refresh"
          >重 置 筛 选</el-button
        >
      </el-form-item>
    </el-form>
    <tablePageComp
      :columnsList="columnsList"
      :dataList="dataList"
      :orderNumConfig="{}"
      :getDataConfig="dataQueryFunc()"
      :updateDataSignObj="{
        updateDataTag,
        resetPageNum: true,
      }"
      :totalCount="totalCount"
    >
      <el-table-column
        slot="is_contract"
        label="合作状态"
        align="center"
        width="100"
      >
        <template slot-scope="{ row }">
          <span v-if="row.is_contract == '合作中'" class="fontColor_theme">
            {{ row.is_contract }}
          </span>
          <span v-if="row.is_contract == '已断约'" class="fontColor_danger">
            {{ row.is_contract }}
          </span>
          <span v-if="row.is_contract == '提前对接'" class="fontColor_warning">
            {{ row.is_contract }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        slot="is_secrecy"
        label="保密协议"
        align="center"
        width="100"
      >
        <template slot-scope="{ row }">
          <span>{{ row.is_secrecy == 1 ? "禁止外宣" : "未签署" }}</span>
        </template>
      </el-table-column>
      <!-- 最高权限人员有销售、组长查看权限 -->
      <el-table-column
        v-if="purviewVal"
        slot="sale_id"
        label="销售"
        align="center"
      >
        <template #default="{ row }">
          {{ row.sale_id }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="purviewVal"
        slot="assign_id_leader"
        label="组长"
        align="center"
      >
        <template #default="{ row }">
          {{ row.assign_id_leader }}
        </template>
      </el-table-column>
    </tablePageComp>
  </el-card>
</template>

<script>
export default {
  name: "detail",
  props: { currentCate: { required: true } },
  data() {
    return {
      totalCount: 0,
      updateDataTag: false,
      dataList: [],
      columnsList: [
        // {
        //   label: "公司名",
        //   prop: "corporate_name",
        //   width: 300,
        // },
        {
          label: "合作状态",
          slotName: "is_contract",
        },
        {
          label: "保密协议",
          slotName: "is_secrecy",
        },
        {
          label: "品牌",
          prop: "brand_name",
        },
        {
          label: "主要产品",
          prop: "main_products",
        },
        {
          label: "归属地",
          prop: "address",
        },
        {
          label: "销售",
          slotName: "sale_id",
        },
        {
          label: "店长",
          prop: "assign_id",
        },
        {
          label: "组长",
          slotName: "assign_id_leader",
        },
      ],
      queryParams: {
        sale_id: "",
        is_contract: "",
        brand_name: "",
        assign_id: "",
        assign_id_leader: "",
        main_products: "",
        address: "",
      },
    };
  },
  watch: {
    currentCate: function () {
      this.updateDataTag = !this.updateDataTag;
    },
  },
  computed: {
    // 查看权限
    purviewVal() {
      return this.$tools.sessionGetStore("jurisdiction") == "0";
    },
    // 组长
    groupList() {
      return this.$store.getters.groupLeaderOptions;
    },
    // 店长选项
    shopList() {
      return this.$store.getters.personInfo.filter(
        (item) => item.department == "4"
      );
    },
    saleList() {
      return this.$store.getters.personInfo.filter(
        (item) => item.department == "5"
      );
    },
  },
  methods: {
    searchHandle() {
      this.$tools.debounceFunc(() => {
        this.updateDataTag = !this.updateDataTag;
      }, 200);
    },
    resetHandle() {
      Object.keys(this.queryParams).forEach((key) => {
        this.queryParams[key] = "";
      });
      this.updateDataTag = !this.updateDataTag;
    },
    dataQueryFunc() {
      let paramObj = {
        category: this.currentCate,
        ...this.queryParams,
      };
      return {
        apiName: "getCustomerCategory",
        paramObj,
        success: function (res, callBack) {
          // console.log(res);
          let records = res.data.data.list,
            arr = [];
          records.forEach((item) => {
            Object.keys(item).forEach((key) => {
              if (item[key] == "null" || item[key] == "undefined" || !item[key])
                item[key] = "";
            });
            arr.push(item);
          });
          this.dataList = arr;
          this.totalCount = res.data.data.count;

          if (callBack) {
            callBack();
          }
        }.bind(this),
        failed: function (error, callBack) {
          if (callBack) callBack();
        },
      };
    },
  },
};
</script>

<style lang="scss">
.pageBox {
  padding-top: 20px;
}
</style>
